import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModuliPopisService } from './moduli-popis.service';
import { ModulPopis } from './modul';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';
import * as alertify from 'alertify.js';
declare var $: any;

@Component({
  selector: 'app-moduli-popis',
  templateUrl: './moduli-popis.component.html',
  styleUrls: ['./moduli-popis.component.css'],
  providers: [ModuliPopisService]
})
export class ModuliPopisComponent implements OnInit {

  sviModuli: ModulPopis[] = [];
  modulOptions: DataTables.Settings = {};
  modulTrigger: Subject<ModulPopis> = new Subject();

  modulForma: FormGroup;
  modulEditForma: FormGroup;
  modulNastavnaJedinicaForma: FormGroup;

  modulId: string;

  svenastavnejedinice: any = [];
  svapodrucjaznanja: any = [];
  svimodulinewpopis: any = [];

  constructor(
    private _fb: FormBuilder,
    private _moduliPopisService: ModuliPopisService
  ) { }

  ngOnInit() {
    this.dohvati();
    /* zbog "filtera" nastavnih jedinica po podrucju znanja izbaceno i preureden api */
    /* this.dohvatiSveAktivneNastavneJedinice(); */
    this.dohvatiSvaAktivnaPodrucjaznanja();
    this.dohvatiSveModuleNewPopis();
    //Tablica početak
    this.modulOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
        targets: 'no-sort',
        orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.modulForma = this._fb.group({
      naziv: [''],
      podrucjeZnanja: [''],
      nastavnaJedinica: ['']
    });
    this.modulEditForma = this._fb.group({
      naziv: [''],
      podrucjeZnanja: {value: '', disabled: true},
      nastavnaJedinica: [''],
      aktivan: [''],
      redoslijedIzvodenja: ['']
    });
    this.modulNastavnaJedinicaForma = this._fb.group({
      modulnew: [''],
      podrucjeZnanja: [''],
      nastavnaJedinica: [''],
      aktivan: ['']
    });

    this.osvjeziMultiselect();
  }

  osvjeziMultiselect(){
    /* potrebno za multiselect (dinamicki podatci) */
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 150);
  }

  pripremiPodatke(modul){
    //console.log(modul);
    this.modulId = modul['id'];
    this.modulEditForma = this._fb.group({
      naziv: modul['naziv'],
      podrucjeZnanja: modul['idpodrucjeznanja'],
      nastavnaJedinica: modul['idmodul'],
      idmodulnewstavka: modul['idmodulnewstavka'],
      aktivan: modul['aktivan'],
      redoslijedIzvodenja: modul['redoslijedizvodenja']
    });
    this.PodrucjeZnanjaNastavneJedinice(modul.idpodrucjeznanja);
  }

  uredi(modul){
    //console.log(modul);
    let podaciZaSlanje = {
      'idmodulnew': this.modulId,
      'naziv': modul['naziv'],
      'idnastavnajedinica': modul['nastavnaJedinica'],
      'idmodulnewstavka': modul['idmodulnewstavka'],
      'idpodrucjeznanja': modul['podrucjeZnanja'],
      'aktivan': modul['aktivan'],
      'mns_redoslijedizvodjenja': modul['redoslijedIzvodenja'],
      'access_token': localStorage.getItem('tokenSql')
    }
    //console.log(podaciZaSlanje);
    this._moduliPopisService.urediModul(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#moduliTablica').DataTable().destroy();
        this.dohvati();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  PodrucjeZnanjaNastavneJedinice(idpodrucjeznanja){
    // console.log('idpodrucjeznanja: ', idpodrucjeznanja);
    this.svenastavnejedinice = [];
    this._moduliPopisService.dohvatiAktivneNastavnejedinice({'idkorisnik': localStorage.getItem('userId'), idpodrucjeznanja: idpodrucjeznanja}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.svenastavnejedinice = res.data;
        this.osvjeziMultiselect();
      } else {
        this.svenastavnejedinice = [];
      }
    });
    // console.log(this.svenastavnejedinice.length);
  }

  odabraneNastavneJedinice(idnastavnajedinica){
    // console.log('idnastavnajedinica: ', idnastavnajedinica);
  }

  dohvatiSveAktivneNastavneJedinice(){
    this._moduliPopisService.dohvatiAktivneNastavnejedinice({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.svenastavnejedinice = res.data;
      } else {
        this.svenastavnejedinice = [];
      }
    })
  }

  dohvatiSvaAktivnaPodrucjaznanja(){
    this._moduliPopisService.dohvatiAktivnaPodrucjaznanja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.svapodrucjaznanja = res.data[0];
      } else {
        this.svapodrucjaznanja = [];
      }
    })
  }

  spremi(modulForma){
    //console.log(modulForma);
    let objektZaSlanje = {
      'naziv': modulForma['naziv'],
      'idpodrucjeznanja': modulForma['podrucjeZnanja'],
      'idnastavnajedinica': modulForma['nastavnaJedinica']
    };
    // console.log(objektZaSlanje);
    if(modulForma['naziv'] && modulForma['podrucjeZnanja']  && modulForma['nastavnaJedinica']){
      this._moduliPopisService.dodajModul(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodan modul!");
          this.modulForma = this._fb.group({
            naziv: [''],
            podrucjeZnanja: [''],
            nastavnaJedinica: ['']
          });
          $('#moduliTablica').DataTable().destroy();
          this.dohvati();
          this.dohvatiSveModuleNewPopis();
          this.svenastavnejedinice = [];
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.sviModuli = [];
    this._moduliPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviModuli.push({
            'id': res.data[i]['idmodulnew'],
            'idmodulnewstavka': res.data[i]['idmodulnewstavka'],
            'naziv': res.data[i]['mn_nazivmodula'],
            'idmodul': res.data[i]['modul_idmodul'],
            'nazivmodula': res.data[i]['mo_naziv'],
            'idpodrucjeznanja': res.data[i]['idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['pu_naziv'],
            'aktivan': res.data[i]['mns_aktivan'],
            'redoslijedizvodenja': res.data[i]['mns_redoslijedizvodjenja']
          });
        }
        this.modulTrigger.next();

        /* row group datatable */
        $(document).ready(function(){
          var groupColumn = 1;
          var table = $('#moduliTablica').DataTable({
            "columnDefs": [
                { "visible": false, "targets": groupColumn }
            ],
            "order": [[ groupColumn, 'asc' ]],
            "displayLength": 25,
            "drawCallback": function( settings ){
              var api = this.api();
              var rows = api.rows( {page:'current'} ).nodes();
              var last = null;
    
              api.column(groupColumn, {page:'current'} ).data().each( function ( group, i ){
                if( last !== group ){
                  $(rows).eq( i ).before(
                    '<tr class="group"><td colspan="7">'+group+'</td></tr>'
                  );
                  last = group;
                }
              });
            }
          });
       
          // Order by the grouping
          /*
          $('#moduliTablica tbody').on( 'click', 'tr.group', function (){
            var currentOrder = table.order()[0];
            if(currentOrder[0] === groupColumn && currentOrder[1] === 'asc' ){
              table.order( [ groupColumn, 'desc' ] ).draw();
            }
            else{
              table.order( [ groupColumn, 'asc' ] ).draw();
            }
          });
          */
        });

      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  obrisiModul(modul){
    //console.log(modul);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati nastavnu jedinicu iz modula?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._moduliPopisService.obrisiModul({'idmodulnewstavka': modul.idmodulnewstavka}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Nastavna jedinica uspješno obrisana!");
            $('#moduliTablica').DataTable().destroy();
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja nastavne jedinice.');
    });
  }

  dohvatiSveModuleNewPopis(){
    this.svimodulinewpopis = [];
    this._moduliPopisService.dohvatiSveModuleNew({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        this.svimodulinewpopis = res.data;
      }else{
        toastr.error("Neuspješno dohvaćanje modula!");
      }
    })
  }

  odabraniModul(idmodulnew){
    //console.log('idmodulnew: ', idmodulnew);
    for (let i = 0; i < this.svimodulinewpopis.length; i++) {
      if(idmodulnew == this.svimodulinewpopis[i].idmodulnew){
        this.modulNastavnaJedinicaForma = this._fb.group({
          modulnew: this.svimodulinewpopis[i].idmodulnew,
          podrucjeZnanja: [''],
          nastavnaJedinica: [''],
          aktivan: this.svimodulinewpopis[i].mn_aktivan
        });
      }
    }
  }

  urediModul_addNastavnejedinice(modulNastavnaJedinicaForma){
    //console.log(modulNastavnaJedinicaForma);
    let objektZaSlanje = {
      'idmodulnew': modulNastavnaJedinicaForma['modulnew'],
      'aktivan': modulNastavnaJedinicaForma['aktivan'],
      'idpodrucjeznanja': modulNastavnaJedinicaForma['podrucjeZnanja'],
      'idnastavnajedinica': modulNastavnaJedinicaForma['nastavnaJedinica'],
      'access_token': localStorage.getItem('tokenSql')
    };
    //console.log(objektZaSlanje);
    if(modulNastavnaJedinicaForma['modulnew']){
      this._moduliPopisService.editModul_AddNastavnejedinice(objektZaSlanje).subscribe(res =>{
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno uređivanje!");
          this.modulNastavnaJedinicaForma = this._fb.group({
            modulnew: [''],
            podrucjeZnanja: [''],
            nastavnaJedinica: [''],
            aktivan: ['']
          });
          $('#moduliTablica').DataTable().destroy();
          this.dohvati();
          this.dohvatiSveModuleNewPopis();
        } else {
          toastr.error("Neuspješno uređivanje!");
        }
      });
    }else{
      toastr.error("Unesite potrebne podatke!");
    }
  }

}




// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/moduli-popis/moduli-popis.component.ts